'use strict';

var ROLE_NAV = {
  'Page Order': [
    'merch-management.views',
    'queue.inbound',
    'queue.merch-prep',
    'queue.post-prod',
    'queue.qa',
    'outreachQueue.outreach',
  ],
  'Super User': [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
    {
      label: 'QA',
      state: 'queue.qa'
    },
  ],
  'Merch Ops': [
  ],
  'Studio Ops': [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
    {
      label: 'QA',
      state: 'queue.qa'
    },
  ],
  'Studio Stylist': [
  ],
  'Digi Tech': [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
  ],
  'Image Editor': [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
  ],
  'Senior Image Editor': [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
  ],
  'External Image Editor': [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
  ],
  Photographer: [
    {
      label: 'Post',
      state: 'queue.post-prod'
    },
  ],
  'QA Reviewer': [
    {
      label: 'QA',
      state: 'queue.qa'
    }
  ]
};

module.exports = ROLE_NAV;
